import { useEffect } from 'react';
import { useAppBridge } from "@shopify/app-bridge-react";

export default function Loading() {
    const app = useAppBridge();

    useEffect(() => {
        // Start global loading overlay when component is mounted
        app.loading(true);

        // Stop loading overlay when component is unmounted
        return () => {
            app.loading(false);
        };
    }, [app]);

    return null;
}
